import React from "react";
import PropTypes from "prop-types";
import { Box, Grid, Typography } from "@mui/material";

// One block of a settings tab: title and explanation on the left, fields on the right (stacked on phones).
function SettingsSection({ title, description, children, last }) {
  return (
    <Box
      sx={{
        py: 3,
        borderBottom: last ? "none" : "1px solid",
        borderColor: "divider",
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Typography variant="subtitle1" fontWeight={600}>
            {title}
          </Typography>
          {description && (
            <Typography variant="body2" color="text.secondary" mt={0.5}>
              {description}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} md={8}>
          <Box display="flex" flexDirection="column" gap={2}>
            {children}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

SettingsSection.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  children: PropTypes.node.isRequired,
  last: PropTypes.bool,
};

SettingsSection.defaultProps = {
  description: null,
  last: false,
};

export default SettingsSection;
